import { Box } from "@mui/material";
import { useTheme } from "@mui/styles";
import React from "react";

import { PanelButtonProps } from "../../@types/Components";
import useResponsiveSizes from "../../hooks/useResponsiveSizes";

const PanelButton = (props: PanelButtonProps): React.JSX.Element => {
    const theme = useTheme();
    const { id, innerContent, onClick, onHover, disabled } = props;
    const sizes = useResponsiveSizes();

    return (
        <Box
            component={"div"}
            id={id}
            onClick={disabled ? undefined : onClick} // Disable clicks
            onMouseOver={disabled ? undefined : onHover} // Disable hover effects
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "1rem",
                width: "max-content",
                minWidth: "95%",
                height: sizes.panelHeight,
                backgroundColor: disabled ? theme.palette.grey[500] : theme.palette.secondary.main, // Greyed out when disabled
                cursor: disabled ? "not-allowed" : "pointer", // Change cursor
                opacity: disabled ? 0.5 : 1, // Reduce opacity
                pointerEvents: disabled ? "none" : "auto", // Prevent interactions
                transition: ".25s ease-in-out",
                "&:hover": disabled
                    ? {} // No hover effect when disabled
                    : {
                          bgcolor: "#32affd",
                          boxShadow: "0 0 3px 3px rgba(0, 0, 0, .25)",
                          transition: ".25s ease-in-out"
                      }
            }}
        >
            {innerContent}
        </Box>
    );
};

export default PanelButton;